import { render } from "./MonitoringDetailsHeader.vue?vue&type=template&id=24c87d4e&scoped=true&ts=true"
import script from "./MonitoringDetailsHeader.vue?vue&type=script&lang=ts"
export * from "./MonitoringDetailsHeader.vue?vue&type=script&lang=ts"

import "./MonitoringDetailsHeader.vue?vue&type=style&index=0&id=24c87d4e&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/hems-frontend-vue_au_v1.33.0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24c87d4e"]])

export default __exports__